import React, { Component }  from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Table, Button } from 'antd'
import update from 'immutability-helper'
import { DndProvider, DragSource, DropTarget } from 'react-dnd-cjs'
import HTML5Backend from 'react-dnd-html5-backend-cjs'
 

import CustomIconMath from '../../IconSVG/CustomIconMath.svg' 
import ExerciseIconMath from '../../IconSVG/ExerciseIconMath.svg' 
 
import CompetitionMathIcon from '../../IconSVG/CompetitionMathIcon.svg'
import IconExamMath from '../../IconSVG/IconExamMath.svg' 
import './Suggest.scss'

let dragingIndex = -1


class BodyRow extends React.Component {
  render() {
    const { isOver, connectDragSource, connectDropTarget,  ...restProps } = this.props
    const style = { ...restProps.style, cursor: 'move' }

    let { className } = restProps
    if (isOver) {
      if (restProps.index > dragingIndex) {
        className += ' drop-over-downward'
      }
      if (restProps.index < dragingIndex) {
        className += ' drop-over-upward'
      }
    }

    return connectDragSource(
      connectDropTarget(<tr {...restProps} className={className} style={style} />),
    )
  }
}
const rowSource = {
  beginDrag(props) {
    dragingIndex = props.index
    return {
      index: props.index,
    }
  },
}
const rowTarget = {
  drop(props, monitor) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index

    // Don't replace items with themselves
    if (dragIndex === hoverIndex) {
      return
    }

    // Time to actually perform the action
    props.moveRow(dragIndex, hoverIndex)

    // Note: we're mutating the monitor item here!
    // Generally it's better to avoid mutations,
    // but it's good here for the sake of performance
    // to avoid expensive index searches.
    monitor.getItem().index = hoverIndex
  },
}
const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
}))(
  DragSource('row', rowSource, connect => ({
    connectDragSource: connect.dragSource(),
  }))(BodyRow),
)
class SuggestMath extends Component {
  constructor(props){
    super(props)
    this.state = {
      examMath: []
    }
  }
  components = {
    body: {
      row: DragableBodyRow,
    },
  }
  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps = (nextProps) => {
    if(this.props.data !== nextProps.data){
      this.setState({
        examMath: nextProps.data
      })
    }
  }

  moveRow = async(dragIndex, hoverIndex) => {
    const { updateSeq } = this.props
    const { examMath } = this.state
    const dragRow = examMath[dragIndex]
    let date = {seq: hoverIndex}
    await this.setState(
      update(this.state, {
        examMath: {
          $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]],
        },
      }),
    )
    await updateSeq(examMath[dragIndex]._id,date)
  }
  render(){
    const { columns,role, hoverCodeExam } = this.props
    let { examMath } = this.state  
    
    return (
      <div className='suggest'>
        <div className='mobile'>
          {
            examMath.map((examSet, i) => {
              const type = examSet.type 
              const name = examSet.name
              let logo = null 
              if(examSet.type === 'G') {
                logo = IconExamMath
              } else if(examSet.type === 'C'){
                logo = CompetitionMathIcon
              }else if(examSet.type === 'CUSTOM'){
                logo = CustomIconMath
              }else if(examSet.type === 'EX' || examSet.type === 'E'){
                logo = ExerciseIconMath
              } 
              return (
                <Link to={`/examset/${examSet._id}`}
                  className='suggest-item'
                  key={i}>
                  <div className='suggest-item-name'>
                    <img src={logo} />

                    <div className='content'>
                      <h4>{name}</h4>
                      <p>{examSet.code}</p>
                      <p>
                        ประเภท :
                        <span>
                          {
                            type === 'G' ? 'ตามหลักสูตร' : 
                            type === 'C' ? 'แข่งขัน' : 
                            type === 'CUSTOM' ? 'กำหนดเอง' : 
                            (type === 'EX' || type === 'E') ? 'แบบฝึกหัด': 
                            type === 'CAT' ? 'CAT' : '-'
                          }
                        </span>
                      </p>
                    </div>

                  </div>

                  <div className='action'>
                    <Button type='secondary'>
                      เริ่มทำ
                    </Button>
                  </div>
                </Link>
              )
            })
          }
        </div>

        <div className='desktop'>
          {
            role === 'admin' ?
              <DndProvider backend={HTML5Backend}>
                <Table
                  // scroll={{x:true}} 
                  rowKey={(record,i) => i}
                  columns={columns}
                  dataSource={examMath}
                  pagination={false}
                  onRow={(examSet, index) => {
                    return {
                      onClick: e => {
                        e.stopPropagation()
                        this.props.history.push(`/suggest/${examSet._id}`)
                      },
                      index,
                      moveRow: this.moveRow,
                      onMouseEnter: e => { e.stopPropagation(); this.props.setIndexRow(index) }
                    }
                  }}
                  components={this.components}
                />
              </DndProvider>
              : <Table
                // scroll={{x:true}}
                rowKey={(record,i) => i}
                columns={columns}
                dataSource={examMath}
                pagination={false}
                onRow={(examSet, index) => { 
                  return {
                    onClick: e => {
                      e.stopPropagation()
                      if(!hoverCodeExam) this.props.history.push(`/suggest/${examSet._id}`)
                    },
                    onMouseEnter: e => { e.stopPropagation(); this.props.setIndexRow(index) }
                  }
                }}
              />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = () => {
  return {

  }
}
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {

    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(SuggestMath)
